import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class CrowFlyTool extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var routingTool = this;
		setTimeout(function(){
			routingTool.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var routingTool = this;

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookupStart',
					label: 'Start Location',
					style: 'margin-left: 5px;',
					textstyle: 'width: 250px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookupEnd',
					label: 'End Location',
					style: 'margin-left: 5px;',
					textstyle: 'width: 250px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:road', ' Route')
					], 
					listeners: {
						click: function() {
							actionRoute();
						}
					}
				}			
			]
		});		
		
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [							
				{						
					path: 'field',
					header: 'Field',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.highlight) {
							root.style.backgroundColor = '#dbf6ff';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.field;
					}
				},	
				{						
					path: 'value',
					header: 'Value',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				}
			}
		});	
				
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'crowFlyTool',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		routingTool.append(flexLayout);	
		
		
		var actionRoute = function() {
			var locationStartField = ElementUtil.query(toolbar, 'locationLookupStart');
			var locationStart = locationStartField.getValue();
			
			var locationEndField = ElementUtil.query(toolbar, 'locationLookupEnd');
			var locationEnd = locationEndField.getValue();
			
			if (locationStart === '' || locationEnd === '') {							
				window.DL.MessageUtil.showOkMessage('Start and End location required');			 
			} else {
				var loadMask = grid.showLoading();
				
				RoutingService.getRoutingToolsService().geocode({
					rawLocation: locationStart
				}).then(function(startArray) {
					var start = startArray[0];
					if (!start.latitude || !start.longitude) {											
						locationStartField.markError('Invaild location');
						loadMask.remove();
					} else {										
						RoutingService.getRoutingToolsService().geocode({
							rawLocation: locationEnd
						}).then(function (endArray) {
							var end = endArray[0];							
							if (!end.latitude || !end.longitude) {											
								locationEndField.markError('Invaild location');
								loadMask.remove();
							} else {
								var request = {
									startLat: start.latitude,
									startLong: start.longitude,
									endLat: end.latitude,
									endLong: end.longitude
								};
								
								if (routingTool.routeOptions) {
									request.engineOptions = routingTool.routeOptions;
								}
								
								RoutingService.getRoutingToolsService().crowFly(request).then(function (results) {
									loadMask.remove();

									var keyValues = [];
									keyValues.push({
										field: 'Distance Miles',
										value: results.distanceMiles										
									});
									
									keyValues.push({
										field: 'Distance Kilometer',
										value: results.distanceKm										
									});									

									grid.items = keyValues;
								});
							}
						});
					}					
				});
				
			}
		};
		
	}
	
}
customElements.define('dl-crowfly-tool', CrowFlyTool);
